<template>
  <div class="table-cell-stacked">
    <div class="table-cell-stacked__primary">
      <slot name="primary">{{ primary }}</slot>
    </div>
    <div v-if="secondary || $slots.secondary" class="table-cell-stacked__secondary">
      <slot name="secondary">{{ secondary }}</slot>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import type { TableCellStackedProps } from './types'

export default Vue.extend<any, any, any, TableCellStackedProps>({
  name: 'TableCellStacked',
  props: {
    primary: {
      type: String,
      required: true
    },
    secondary: {
      type: String,
      default: undefined
    }
  }
})
</script>

<style scoped>
.table-cell-stacked {
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
}

.table-cell-stacked__primary {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25;
}

.table-cell-stacked__secondary {
  font-size: 0.75rem;
  color: var(--muted-foreground);
  line-height: 1.2;
}
</style>
